import {Injectable} from '@angular/core';
import { LandingModelService } from './landingModel.service';

@Injectable({
  providedIn: 'root'
})
export class OscardStaticService {
  
  constructor(private landingModelService: LandingModelService) {}

  getBankPictureUrl(bankCode: string): string {
    return `//${this.landingModelService.getLandingModel().country}.staticontent.com/oscard/latest/original/${bankCode}.png`;
  }
}